module.exports = __webpack_public_path__ + "assets/materialdesignicons-webfont.a1a0ed860f50ffd42ba46d7c10f30255.eot";